import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const contactSchema = z.object({
  name: z.string().trim().min(1).max(100),
  email: z.string().trim().email().max(200),
  phone: z.string().trim().max(40).optional().default(""),
  interest: z.string().trim().max(100).optional().default(""),
  message: z.string().trim().max(4000).optional().default(""),
});

export const sendContactInquiry = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => contactSchema.parse(data))
  .handler(async ({ data }) => {
    const { sendTemplateEmail } = await import("@/lib/email-templates/send-email");

    try {
      const result = await sendTemplateEmail("contact-inquiry", "wisella@aol.com", {
        templateData: {
          name: data.name,
          email: data.email,
          phone: data.phone,
          interest: data.interest,
          message: data.message,
        },
        replyTo: data.email,
      });
      return { ok: result.sent };
    } catch (error) {
      console.error("contact inquiry send failed", error);
      throw new Error("send_failed");
    }
  });

